module.exports = __webpack_public_path__ + "img/bg-circles-1.1e9698d.svg";